import './prototype'



// WEBPACK FOOTER //
// ./src/yxyweb/common/helpers/polyfill.jsx